import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageSpinComponent } from './page-spin.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@NgModule({
  declarations: [PageSpinComponent],
  imports: [CommonModule, NzSpinModule],
  exports: [PageSpinComponent],
})
export class PageSpinModule {}
